import { useQuery } from "urql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";
import { TagsQuery, TagsQueryVariables } from "../gql/graphql";

export function useTagsQuery(
  bucket: string,
): ReadonlyArray<string> | undefined {
  const [result] = useQuery({
    query: tagsQuery,
    variables: { bucket },
  });

  const { data } = result;

  return data?.tags;
}

export const tagsQuery: TypedDocumentNode<TagsQuery, TagsQueryVariables> =
  graphql(`
    query tags($bucket: String!) {
      tags(bucket: $bucket)
    }
  `);
